<template>
    <nav class="context">
      <div class="context-title" :class="{'context-title-collapsed': visible === false}" @click.stop="toggle">
        <transition name="fade-fast" mode="out-in">
          <h1 v-if="visible === true" key="tit-toc-unscrolled" class="istitle"><span v-html="title"/><span v-html="author"/></h1>
          <h1 v-else key="tit-toc-scrolled"><span v-html="$root.t('context_toc')"/></h1>
        </transition>
      </div>
      <div class="context-tray" :class="{'context-tray-visible': visible === true}">
        <Toc
          :toc="toc"
          :bibliography="bibliography"
          :index="index"
          :images="images"
          :active="active"
          :imprint="imprint"
          :acknowledgments="acknowledgments"
          :citation="citation"
          :doi="doi"
          :meta="meta"
          :hasParts="hasParts"
          :annexPDF="annexPDF"
        />
      </div>
    </nav>
</template>

<script>

import Toc from '../components/Toc.vue'

export default {
  name: 'Context',
  components: {
    Toc
  },
  props: [
    'toc', 'bibliography', 'index', 'images', 'title', 'author', 'active', 'hasParts', 'imprint', 'acknowledgments', 'meta', 'citation', 'doi', 'scrolled', 'annexPDF'
  ],
  data () {
    return ({
      visible: false
    })
  },
  mounted () {
    this.navigationOpenedListener = (e) => {
      if (e === true) this.$root.contextOpen = this.visible = false
    }
    this.extraOpenedListener = (e) => {
      if (e.visible === true) this.$root.contextOpen = this.visible = false
    }
    this.contextOpenedListener = (e) => {
      this.visible = this.$root.overlay = this.$root.contextOpen = e
    }
    this.$root.$on('navigation-opened', this.navigationOpenedListener)
    this.$root.$on('context-opened', this.contextOpenedListener)
    this.$root.$on('extra-opened', this.extraOpenedListener)
  },
  beforeDestroy () {
    this.$root.$off('navigation-opened', this.navigationOpenedListener)
    this.$root.$off('context-opened', this.contextOpenedListener)
    this.$root.$off('extra-opened', this.extraOpenedListener)
  },
  methods: {
    toggle () {
      this.$root.$emit('context-opened', !this.visible)
    }
  }
}
</script>

<style lang="scss">

@import '../main';
.context {
  right: 0px;
  pointer-events: none;
  &-tray {
    background: var(--context-tray-color);
    color: var(--context-tray-font-color);
    width: var(--menuwidth);
    right: 0px;
    transform: translateX(100%);
    display: flex;
    flex-direction: column;
    pointer-events: all;
  }
  &-title {
    right: 0px;
    background: var(--context-color);
    color: var(--context-font-color);
    pointer-events: all;
    h1 {
      span {
        text-transform: uppercase;
      }
      &.istitle {
        br {
          display: none;
        }
        span:last-child {
          text-transform: none;
        }
      }
    }
    transition: var(--nav-hoover-anim);
    &-collapsed {
      @include hover() {
        transform: translateX(0);
      }
    }
  }
}
@include sm() {
  .book-extra {
    .context {
      &-title {
        @include lvh(50, 'height', '!important');
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Context.vue